import axios from "axios";
import { handleAxiosErrors, getRessource } from "../utils";

const SRO = "/sro";
const GET_SRO_ZA_BY_CODES_RESEAU = `${SRO}/get-sroza-by-codesreseau`;

// récupère les ZASRO avec possibilité de stopper le fetch
export const getSroZaByCodesReseau = (codesReseau, abort) =>
  axios
    .get(GET_SRO_ZA_BY_CODES_RESEAU, {
      params: {
        codesReseau,
      },
      signal: abort.signal,
    })
    .then(response => handleAxiosErrors(response))
    .then(url => getRessource(url, abort))
    .catch(error => Promise.reject(error));
